/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AnalyticsExportLinkResponse,
  CreateAnalyticsExportLinkModel,
  MintAdminMcpTokenForVerifiedEmailModel,
  MintAdminMcpTokenModel,
  MintAdminMcpTokenResponse,
  MintMcpAccessTokenForVerifiedAdminEmailResult,
  ProblemDetails,
  RefreshAdminMcpTokenModel,
  RetrievePagedInvocationsParams
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Retrieves a paged list of MCP tool invocations recorded for the specified platform, optionally filtered by outcome.
 */
export const retrievePagedInvocations = (
    platformId: string,
    params?: RetrievePagedInvocationsParams,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platforms/${platformId}/mcp/invocations`, method: 'GET',
        params, signal
    },
      );
    }




export const getRetrievePagedInvocationsQueryKey = (platformId: string,
    params?: RetrievePagedInvocationsParams,) => {
    return [
    `/api/v1/platforms/${platformId}/mcp/invocations`, ...(params ? [params] : [])
    ] as const;
    }


export const getRetrievePagedInvocationsQueryOptions = <TData = Awaited<ReturnType<typeof retrievePagedInvocations>>, TError = ErrorType<unknown>>(platformId: string,
    params?: RetrievePagedInvocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrievePagedInvocations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrievePagedInvocationsQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrievePagedInvocations>>> = ({ signal }) => retrievePagedInvocations(platformId,params, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrievePagedInvocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RetrievePagedInvocationsQueryResult = NonNullable<Awaited<ReturnType<typeof retrievePagedInvocations>>>
export type RetrievePagedInvocationsQueryError = ErrorType<unknown>


export function useRetrievePagedInvocations<TData = Awaited<ReturnType<typeof retrievePagedInvocations>>, TError = ErrorType<unknown>>(
 platformId: string,
    params: undefined |  RetrievePagedInvocationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrievePagedInvocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrievePagedInvocations>>,
          TError,
          Awaited<ReturnType<typeof retrievePagedInvocations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrievePagedInvocations<TData = Awaited<ReturnType<typeof retrievePagedInvocations>>, TError = ErrorType<unknown>>(
 platformId: string,
    params?: RetrievePagedInvocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrievePagedInvocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrievePagedInvocations>>,
          TError,
          Awaited<ReturnType<typeof retrievePagedInvocations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrievePagedInvocations<TData = Awaited<ReturnType<typeof retrievePagedInvocations>>, TError = ErrorType<unknown>>(
 platformId: string,
    params?: RetrievePagedInvocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrievePagedInvocations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a paged list of MCP tool invocations recorded for the specified platform, optionally filtered by outcome.
 */

export function useRetrievePagedInvocations<TData = Awaited<ReturnType<typeof retrievePagedInvocations>>, TError = ErrorType<unknown>>(
 platformId: string,
    params?: RetrievePagedInvocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrievePagedInvocations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRetrievePagedInvocationsQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRetrievePagedInvocationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof retrievePagedInvocations>>, TError = ErrorType<unknown>>(platformId: string,
    params?: RetrievePagedInvocationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrievePagedInvocations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrievePagedInvocationsQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrievePagedInvocations>>> = ({ signal }) => retrievePagedInvocations(platformId,params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrievePagedInvocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type RetrievePagedInvocationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof retrievePagedInvocations>>>
export type RetrievePagedInvocationsSuspenseQueryError = ErrorType<unknown>


export function useRetrievePagedInvocationsSuspense<TData = Awaited<ReturnType<typeof retrievePagedInvocations>>, TError = ErrorType<unknown>>(
 platformId: string,
    params: undefined |  RetrievePagedInvocationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrievePagedInvocations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrievePagedInvocationsSuspense<TData = Awaited<ReturnType<typeof retrievePagedInvocations>>, TError = ErrorType<unknown>>(
 platformId: string,
    params?: RetrievePagedInvocationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrievePagedInvocations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrievePagedInvocationsSuspense<TData = Awaited<ReturnType<typeof retrievePagedInvocations>>, TError = ErrorType<unknown>>(
 platformId: string,
    params?: RetrievePagedInvocationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrievePagedInvocations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a paged list of MCP tool invocations recorded for the specified platform, optionally filtered by outcome.
 */

export function useRetrievePagedInvocationsSuspense<TData = Awaited<ReturnType<typeof retrievePagedInvocations>>, TError = ErrorType<unknown>>(
 platformId: string,
    params?: RetrievePagedInvocationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof retrievePagedInvocations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRetrievePagedInvocationsSuspenseQueryOptions(platformId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Mints an MCP access token for the authenticated admin user scoped to the specified platform.
 */
export const mintToken = (
    mintAdminMcpTokenModel: MintAdminMcpTokenModel,
 signal?: AbortSignal
) => {


      return customAxios<MintAdminMcpTokenResponse>(
      {url: `/api/v1/mcp/auth/token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mintAdminMcpTokenModel, signal
    },
      );
    }




export const getMintTokenMutationKey = () => ['mintToken'] as const;

export const getMintTokenMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mintToken>>, TError,MintTokenMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof mintToken>>, TError,MintTokenMutationVariables, TContext> => {

const mutationKey = getMintTokenMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mintToken>>, MintTokenMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  mintToken(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MintTokenMutationResult = NonNullable<Awaited<ReturnType<typeof mintToken>>>
    export type MintTokenMutationBody = MintAdminMcpTokenModel
    export type MintTokenMutationError = ErrorType<unknown>
    export type MintTokenMutationVariables = {data: MintAdminMcpTokenModel}

    /**
 * @summary Mints an MCP access token for the authenticated admin user scoped to the specified platform.
 */
export const useMintToken = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mintToken>>, TError,MintTokenMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mintToken>>,
        TError,
        MintTokenMutationVariables,
        TContext
      > => {
      return useMutation(getMintTokenMutationOptions(options), queryClient);
    }
    /**
 * @summary Mints an MCP access token for a verified admin email address via the email gateway workspace key, rate-limiting ineligible senders to prevent enumeration.
 */
export const mintTokenForVerifiedEmail = (
    mintAdminMcpTokenForVerifiedEmailModel: MintAdminMcpTokenForVerifiedEmailModel,
 signal?: AbortSignal
) => {


      return customAxios<MintMcpAccessTokenForVerifiedAdminEmailResult>(
      {url: `/api/v1/mcp/auth/token/mint-for-verified-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mintAdminMcpTokenForVerifiedEmailModel, signal
    },
      );
    }




export const getMintTokenForVerifiedEmailMutationKey = () => ['mintTokenForVerifiedEmail'] as const;

export const getMintTokenForVerifiedEmailMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mintTokenForVerifiedEmail>>, TError,MintTokenForVerifiedEmailMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof mintTokenForVerifiedEmail>>, TError,MintTokenForVerifiedEmailMutationVariables, TContext> => {

const mutationKey = getMintTokenForVerifiedEmailMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mintTokenForVerifiedEmail>>, MintTokenForVerifiedEmailMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  mintTokenForVerifiedEmail(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MintTokenForVerifiedEmailMutationResult = NonNullable<Awaited<ReturnType<typeof mintTokenForVerifiedEmail>>>
    export type MintTokenForVerifiedEmailMutationBody = MintAdminMcpTokenForVerifiedEmailModel
    export type MintTokenForVerifiedEmailMutationError = ErrorType<ProblemDetails>
    export type MintTokenForVerifiedEmailMutationVariables = {data: MintAdminMcpTokenForVerifiedEmailModel}

    /**
 * @summary Mints an MCP access token for a verified admin email address via the email gateway workspace key, rate-limiting ineligible senders to prevent enumeration.
 */
export const useMintTokenForVerifiedEmail = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mintTokenForVerifiedEmail>>, TError,MintTokenForVerifiedEmailMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mintTokenForVerifiedEmail>>,
        TError,
        MintTokenForVerifiedEmailMutationVariables,
        TContext
      > => {
      return useMutation(getMintTokenForVerifiedEmailMutationOptions(options), queryClient);
    }
    /**
 * @summary Refreshes an existing MCP access token for the administrator on the platform, enforcing a per-token rate limit.
 */
export const refreshToken = (
    refreshAdminMcpTokenModel: RefreshAdminMcpTokenModel,
 signal?: AbortSignal
) => {


      return customAxios<MintAdminMcpTokenResponse>(
      {url: `/api/v1/mcp/auth/token/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshAdminMcpTokenModel, signal
    },
      );
    }




export const getRefreshTokenMutationKey = () => ['refreshToken'] as const;

export const getRefreshTokenMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshToken>>, TError,RefreshTokenMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof refreshToken>>, TError,RefreshTokenMutationVariables, TContext> => {

const mutationKey = getRefreshTokenMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshToken>>, RefreshTokenMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  refreshToken(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshTokenMutationResult = NonNullable<Awaited<ReturnType<typeof refreshToken>>>
    export type RefreshTokenMutationBody = RefreshAdminMcpTokenModel
    export type RefreshTokenMutationError = ErrorType<ProblemDetails>
    export type RefreshTokenMutationVariables = {data: RefreshAdminMcpTokenModel}

    /**
 * @summary Refreshes an existing MCP access token for the administrator on the platform, enforcing a per-token rate limit.
 */
export const useRefreshToken = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshToken>>, TError,RefreshTokenMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshToken>>,
        TError,
        RefreshTokenMutationVariables,
        TContext
      > => {
      return useMutation(getRefreshTokenMutationOptions(options), queryClient);
    }
    /**
 * @summary Creates a short-lived analytics export link that maps a protected export token to the authenticated admin and platform.
 */
export const createAnalyticsExportLink = (
    createAnalyticsExportLinkModel: CreateAnalyticsExportLinkModel,
 signal?: AbortSignal
) => {


      return customAxios<AnalyticsExportLinkResponse>(
      {url: `/api/v1/mcp/auth/analytics-export-links`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAnalyticsExportLinkModel, signal
    },
      );
    }




export const getCreateAnalyticsExportLinkMutationKey = () => ['createAnalyticsExportLink'] as const;

export const getCreateAnalyticsExportLinkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalyticsExportLink>>, TError,CreateAnalyticsExportLinkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAnalyticsExportLink>>, TError,CreateAnalyticsExportLinkMutationVariables, TContext> => {

const mutationKey = getCreateAnalyticsExportLinkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAnalyticsExportLink>>, CreateAnalyticsExportLinkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAnalyticsExportLink(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAnalyticsExportLinkMutationResult = NonNullable<Awaited<ReturnType<typeof createAnalyticsExportLink>>>
    export type CreateAnalyticsExportLinkMutationBody = CreateAnalyticsExportLinkModel
    export type CreateAnalyticsExportLinkMutationError = ErrorType<unknown>
    export type CreateAnalyticsExportLinkMutationVariables = {data: CreateAnalyticsExportLinkModel}

    /**
 * @summary Creates a short-lived analytics export link that maps a protected export token to the authenticated admin and platform.
 */
export const useCreateAnalyticsExportLink = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalyticsExportLink>>, TError,CreateAnalyticsExportLinkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAnalyticsExportLink>>,
        TError,
        CreateAnalyticsExportLinkMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAnalyticsExportLinkMutationOptions(options), queryClient);
    }
